import http from '../http-common';
import Cookies from 'js-cookie';
import { TOKEN } from '../constant';
import { AxiosError } from 'axios';

export const useTimecampService = () => {
  const login = async (payload: Object) => {
    return http
      .post<{ token: string; companyLogo?: string }>('/auth/login', payload)
      .then((res) => res.data);
  };

  const verifyLogin = async () => {
    const authToken = Cookies.get(TOKEN);
    return http.get<{}>('/auth', {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
  };

  const addTimeEntry = async (payload: Object) => {
    const authToken = Cookies.get(TOKEN);
    return http
      .post<{ message: string }>('/user/add-time-entry', payload, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((res) => res.data)
      .catch((e: AxiosError) => {
        throw new Error((e?.response?.data as any).error)
      });
  };

  const pageVisit = async ({  page }: { page: string}) => {
    return http
      .post<{ token: string }>('/user/page-hit', { token: Cookies.get(TOKEN), page })
      .then((res) => res.data);
  };

  return { login, addTimeEntry, verifyLogin, pageVisit };
};
